import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { TextFieldProps } from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import * as CS from '../style';
import InputWrapper from '../InputWrapper';

export type ComponentProps = {
  label?: string;
  hint?: string;
  placeholder: string;
  error?: string | boolean;
  disabled?: boolean;
  mode?: string;
  type?: string;
  height?: string;
  value?: any;
  optional?: boolean;
  control?: any;
  name?: string;
  showHelpIcon?: boolean;
  setShowHint?: React.Dispatch<React.SetStateAction<boolean>>;
} & TextFieldProps;

export const TextField: React.FC<ComponentProps> = (props) => {
  const { placeholder, error, onChange, value, type, name, disabled } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => setShowPassword(!showPassword);

  const isPasswordField = type === 'password';

  return (
    <InputWrapper {...props}>
      <CS.StyledTextField
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        error={!!error}
        type={isPasswordField && !showPassword ? 'password' : 'text'}
        name={name}
        disabled={disabled}
        InputProps={{
          endAdornment: isPasswordField ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleTogglePassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : null
        }}
      />
    </InputWrapper>
  );
};

export const ControllerTextField: React.FC<ComponentProps> = ({
  control,
  name = '',
  label,
  placeholder,
  type = 'input',
  disabled = false,
  ...props
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          name={name}
          type={type}
          placeholder={placeholder}
          label={label}
          value={value || ''}
          onChange={onChange}
          error={error?.message || ''}
          disabled={disabled}
          {...props}
        />
      )}
    />
  );
};

export default TextField;
